
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.501 2h-1V1h-3v1h-8V1h-3v1h-1a3 3 0 00-3 3v15a3 3 0 003 3h16a3 3 0 003-3V5a3 3 0 00-3-3zm0 18h-16V5h1v1h3V5h8v1h3V5h1v15z"}}),_c('path',{attrs:{"d":"M14.501 9.002h-4v4h4v-4zM14.501 14.002h-4v4h4v-4zM19.501 9.002h-4v4h4v-4zM9.501 9.002h-4v4h4v-4zM9.501 14.002h-4v4h4v-4z"}})])
          )
        }
      }
    